// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mh-0";
export var animationContainer = "_mh-1";
export var itemPrice = "_mh-a";
export var itemizedContent = "_mh-9";
export var itemizedHeader = "_mh-7";
export var itemizedRow = "_mh-8";
export var itemizedSection = "_mh-6";
export var modalContent = "_mh-2";
export var orderName = "_mh-3";
export var refundOption = "_mh-4";
export var refundOptionsContainer = "_mh-5";
export var shippingLabel = "_mh-b";
export var totalRow = "_mh-c";